<template>
	<div class="mask" v-if="IsShow">
		<div class="box" :class="[{'four':ProList.length==4,'two':ProList.length==2,'three':ProList.length==3}]">
			<h3 class="title">{{ $t("dggtitle") }}</h3>
			<productList class="product" :IsPopup="false" :productList="ProList"></productList>
			<div class="close" @click="close"></div>
		</div>
	</div>
</template>

<script>
	import productList from "./NewproductList.vue"
	export default {
		name:"MultipleSpecifications",
		data() {
			return {
				ProList:[],
				IsShow:false
			};
		},
		components:{
			productList
		},
		created() {
		},
		methods:{
			open(options){
				this.IsShow = true;
				this.ProList = options;
			},
			close(){
				this.IsShow = false
			}
		},
	}
</script>

<style lang="scss" scoped>
.mask{
	position: fixed;
	left: 0;
	bottom: 0;
	right: 0;
	top: 0;
	z-index: 2000;
	background-color: rgba(0, 0, 0, .4);
	.box{
		position: absolute;
		top: 50%;
		left: 50%;
        height: 545px;
		display: flex;
		flex-direction: column;
		padding: 20px 30px;
		transform: translate(-50%,-50%);
		background-color: #fff;
		border-radius: 20px;
		.title{
			font-size: 18px;
    		color: #6cbf54;
    		font-weight: 800;
			margin-bottom: 10px;
		}
		.product{
			/deep/ .public .public-ul{
				border: none;
				padding-bottom: 0 ;
			}
			/deep/ .public .public-ul .public-ul-li{
				margin-top: 0;
			}
			/deep/ .public .public-ul .public-ul-li:nth-last-child(1){
				margin-right: 0;
			}
		}
		.close {
			cursor: pointer;
			&::after {
				content: "";
				display: block;
				position: absolute;
				right: 10px;
				top: 10px;
				width: 30px;
				height: 30px;
				background: url('../../static/close.png') no-repeat right center;
				background-size: cover;
				z-index: 100;
			}
		}
	}
	.box.four{
		width: 1106px;
	}
	.box.two{
		width: 600px;
	}
	.three{
		width: 850px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/MultipleSpecifications.vue